import { Router } from 'preact-router';
import { clearToken } from './tokenStorage';
import { isApiUrl } from '../constant/apiHosts';

const axios = require('axios').default;

/**
 * Checks if an error response indicates authentication failure.
 * Only treats 401/403 from the device API (mdash.net or the Pro compat layer —
 * see constant/apiHosts.js) as auth errors — responses from
 * backend.kegtron.com are proxy errors (e.g. Square token rejected)
 * and should not clear the user's session.
 * @param {object} error - Axios error object
 * @returns {boolean} True if error is a mDash auth failure
 */
function isAuthError(error) {
  if (!error.response || !error.config) return false;
  const status = error.response.status;
  if (status !== 401 && status !== 403) return false;

  // Only treat device-API responses as session auth errors
  const url = error.config.url || '';
  if (!isApiUrl(url)) return false;

  return true;
}

/**
 * Handles authentication errors by clearing token and redirecting to login
 * @param {object} error - Axios error object
 * @returns {Promise} Rejected promise with the original error
 */
function handleAuthError(error) {
  // Clear the invalid token
  clearToken();

  // Redirect to login page
  if (typeof window !== 'undefined') {
    Router.route('/');
  }

  return Promise.reject(error);
}

/**
 * Sets up axios response interceptor to handle authentication errors globally
 * This should be called once at application startup
 */
export function setupAuthInterceptor() {
  axios.interceptors.response.use(
    // Success case - pass through unchanged
    (response) => response,

    // Error case - check for auth failures
    (error) => {
      if (isAuthError(error)) {
        return handleAuthError(error);
      }
      // Not an auth error - reject normally
      return Promise.reject(error);
    }
  );
}
